import { render, staticRenderFns } from "./Letters.vue?vue&type=template&id=4c3dea7c&scoped=true&"
import script from "./Letters.vue?vue&type=script&lang=js&"
export * from "./Letters.vue?vue&type=script&lang=js&"
import style0 from "./Letters.vue?vue&type=style&index=0&id=4c3dea7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3dea7c",
  null
  
)

export default component.exports